const VUE_APP_GATEWAY_KSH = process.env.VUE_APP_GATEWAY_KSH
const VUE_APP_GATEWAY_QXS = process.env.VUE_APP_GATEWAY_QXS
const VUE_APP_GATEWAY_KNOWLEDGE_MALL = process.env.VUE_APP_GATEWAY_KNOWLEDGE_MALL
const VUE_APP_GATEWAY_MALL = process.env.VUE_APP_GATEWAY_MALL
const VUE_APP_GATEWAY_RISK_CONTROL_API = process.env.VUE_APP_GATEWAY_RISK_CONTROL_API
export const API = {
  // 微信申请签名
  wxConfig: `${VUE_APP_GATEWAY_QXS}public/v1/wechat/token`,
  logOut: `${VUE_APP_GATEWAY_QXS}doctor/v1/log-out`, // 退出登录
  // 趣课堂
  MeetingDetail: `${VUE_APP_GATEWAY_KSH}doctor/v1/meeting/show`,
  getCommentReplyList: `${VUE_APP_GATEWAY_QXS}common/comment/v1/reply/list`,
  KnowledgeDetail: `${VUE_APP_GATEWAY_KSH}public/v1/meeting/knowledge/show`,
  Digg: `${VUE_APP_GATEWAY_QXS}doctor/v1/meeting/digg`,
  questionnaireTimeOnPage: `${VUE_APP_GATEWAY_QXS}common/timer-record/questionnaireTimeOnPage`, // 病例互动答题时长统计轮询请求接口
  getDurationTime: `${VUE_APP_GATEWAY_QXS}common/timer-record/getDurationTime`,
  // 主页
  IndexBanner: `${VUE_APP_GATEWAY_QXS}common/v1/index/wheel-list`,
  IndexMeetingList: `${VUE_APP_GATEWAY_QXS}doctor/v1/meeting/list`, // 首页趣课堂
  IndexSurveyList: `${VUE_APP_GATEWAY_QXS}doctor/v1/survey/list`, // 首页调研
  IndexVisitList: `${VUE_APP_GATEWAY_QXS}doctor/v1/visit/list`, // 首页拜访
  inviteCount: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/scene-notice`, // 首页各种类型的未完成个数
  IndexQuestionnaireList: `${VUE_APP_GATEWAY_QXS}doctor/v1/questionnaire/list`, // 首页问卷
  WxAuth: `${VUE_APP_GATEWAY_QXS}public/v1/lose-token`, // 微信授权
  checkDoctor: `${VUE_APP_GATEWAY_QXS}common/v1/check-user`,
  checkToken: `${VUE_APP_GATEWAY_QXS}public/v1/check-token-is-expire`,
  checkDoctorBindStatus: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/bind-info`,
  getUvipToken: `${VUE_APP_GATEWAY_KSH}public/third/user/login`, // 趣课堂 用友用户授权
  checkConfig: `${VUE_APP_GATEWAY_QXS}doctor/v1/person/config_check`,
  GetVeriCode: `${VUE_APP_GATEWAY_QXS}public/sms-code/v1/send`, // 获取新验证码
  sendMessage: `${VUE_APP_GATEWAY_QXS}public/sms-code/v1/send-message`, // 获取验证码，防止短信轰炸
  UserBind: `${VUE_APP_GATEWAY_QXS}doctor/v2/auth/bind`,
  getBindLimit: `${VUE_APP_GATEWAY_QXS}doctor/v1/get-bind-represent-limit`, // 获取医生和代表绑定时未满足绑定的条件项
  getRepBindLimit: `${VUE_APP_GATEWAY_QXS}public/v1/get-rep-bind-doctor-limit`, // 获取关联顶级组织的代表绑定医生限制规则
  getMobileValidResult: `${VUE_APP_GATEWAY_QXS}doctor/v1/get-mobile-valid-result`, // 获取医生手机号三要素认证结果
  checkDoctorIsRep: `${VUE_APP_GATEWAY_QXS}common/v1/check-doctor-is-represent`, // 判断医生是否也是代表
  userLogin: `${VUE_APP_GATEWAY_QXS}doctor/v1/validate`,
  representInfo: `${VUE_APP_GATEWAY_QXS}public/v1/auth/represent_info`,
  uploadAuth: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/certify-img`,
  // OCR 识别接口
  ocrRecognizeLicense: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/recognize-license`, // OCR 识别执业证书（支持多张图片）
  ocrRecognizeTitle: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/recognize-title`, // OCR 识别职称证明
  getDoctorInfo: `${VUE_APP_GATEWAY_QXS}doctor/v1/person/show`,
  getUvipInfo: `${VUE_APP_GATEWAY_QXS}v1/third/user/userInfo`, // 趣学术 查询用户信息
  updateUserInfo: `${VUE_APP_GATEWAY_KSH}doctor/v1/person/edit`,
  uploadUserAvatar: `${VUE_APP_GATEWAY_KSH}public/v1/person/upload_avatar`,
  doctorGift: `${VUE_APP_GATEWAY_QXS}common/account/statistics`,
  UvipGift: `${VUE_APP_GATEWAY_QXS}v1/third/user/giftCount`, // 趣学术 查询账户总收入和总支出
  doctorReply: `${VUE_APP_GATEWAY_QXS}common/comment/v1/reply`,
  ProblemList: `${VUE_APP_GATEWAY_QXS}doctor/v1/person/comment/list`,
  ReadProblem: `${VUE_APP_GATEWAY_QXS}doctor/v1/person/comment/read`,
  GiftRecord: `${VUE_APP_GATEWAY_QXS}common/account/detail-list`,
  UvipGiftRecord: `${VUE_APP_GATEWAY_QXS}v1/third/user/flow`, // 趣学术 查询用户流水记录
  checkWechat: `${VUE_APP_GATEWAY_QXS}public/v1/wechat/check-mp-subscribe`, // 检查是否有关注公众号
  checkMiniGuide: `${VUE_APP_GATEWAY_QXS}common/v1/ma-floating-notify`, // 小程序引导页接口检查
  getFaceValidUrl: `${VUE_APP_GATEWAY_QXS}common/v1/get-face-auth`, // 获取第三方人脸识别跳转地址
  getFaceAuthUrl: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/face-id-auth`, // 获取第三方人脸识别跳转地址
  getUserFaceConfig: `${VUE_APP_GATEWAY_QXS}public/apply-face-request`, // 获取第三方人脸识别地址
  getFaceValidResult: `${VUE_APP_GATEWAY_QXS}public/v1/get-face-result`, // 获取第三方人脸识别结果
  getFaceAuthResult: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/face-id-info`, // 获取第三方人脸识别结果
  personJobTitle: `${VUE_APP_GATEWAY_QXS}/public/v1/person/job_titles`, // 医生职称列表
  isCanChooseMedicalStudent: `${VUE_APP_GATEWAY_QXS}/doctor/v1/common/is-can-choose-medical-student-identity`, // 是否可以选择医学生

  getAuthRejectReason: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/reject-reason`, // 获取认证审核错误原因
  uploadIdCardImage: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/manual-face-id`, // 上传身份证图片
  getIdCardInfo: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/get-id-card`, // 上传身份证审核 获取身份证信息和上次审核失败结果
  getDoctorCertifyImage: `${VUE_APP_GATEWAY_QXS}doctor/v1/person/certify-img`, // 获取认证医生的胸牌
  getModifyRecordDetail: `${VUE_APP_GATEWAY_QXS}common/v1/modify-detail`, // 获取修改医生信息的记录详情
  getModifyPharmacyDetail: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/get-modify-info`, // 获取修改医生信息的记录详情
  confirmModifyRecord: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/confirm-modify-detail`, // 操作是否修改医生信息的记录
  submitPharmacyImage: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/add-drugstore-image`, // 上传药店照片
  confirmPharmacyRecord: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/confirm-update/drugstore-modify-info`, // 操作是否修改医生信息的记录
  confirmPharmacyUserRecord: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/confirm-update/drugstore-doctor-modify-info`, // 操作是否修改医生信息的记录
  getSceneCode: `${VUE_APP_GATEWAY_QXS}doctor/v1/code/scene-code`, // 医生单个场景任务完成情况

  // 商城·地址
  getSearchSuggestions: `${VUE_APP_GATEWAY_MALL}product/search/getSearchSuggestions`, // 阿里云opensearch搜索下拉提示
  getHotSearchAndHintData: `${VUE_APP_GATEWAY_MALL}product/search/getHotSearchAndHintData`, // 阿里云opensearch获取热搜和底纹数据
  DeleteAddress: `${VUE_APP_GATEWAY_MALL}address/deleteUserAddress`,
  ShopList: `${VUE_APP_GATEWAY_MALL}product/productList`, // 商品搜索
  getProductFilterItemsByKeyWord: `${VUE_APP_GATEWAY_MALL}product/getProductFilterItemsByKeyWord`, // 商品过滤搜索
  ShopDetail: `${VUE_APP_GATEWAY_MALL}product/getDetail`, // 商品详情
  clearProduct: `${VUE_APP_GATEWAY_MALL}cart/cleanItem`, // 清理商品
  newShopList: `${VUE_APP_GATEWAY_KSH}public/v1/commodity/newest_list`,
  getShopLevel: `${VUE_APP_GATEWAY_QXS}common/v1/commodity-type-level-one`,
  getShopSpecialList: `${VUE_APP_GATEWAY_QXS}common/v1/subject/subject-list`,
  UpdateAddress: `${VUE_APP_GATEWAY_MALL}address/updateUserAddress`,
  GetAddressList: `${VUE_APP_GATEWAY_MALL}address/getAddressByUserId`,
  AddressDetail: `${VUE_APP_GATEWAY_MALL}address/getUserAddressDetail`,
  AddAddress: `${VUE_APP_GATEWAY_MALL}address/addUserAddress`,
  cityInfo: `${VUE_APP_GATEWAY_QXS}public/v1/address/provinces`,
  getAttribution: `${VUE_APP_GATEWAY_MALL}product/call-info`, // 获取归属地
  getProvincePostage: `${VUE_APP_GATEWAY_QXS}common/v1/postage-get`, // 各省市邮费
  chargeMobile: `${VUE_APP_GATEWAY_MALL}product/call-charge`, // 话费兑换
  checkPhoneTime: `${VUE_APP_GATEWAY_MALL}product/checkPhoneTime`, // 话费兑换频次校验
  chargeList: `${VUE_APP_GATEWAY_MALL}product/recharge-list`, // 话费列表
  specialShopList: `${VUE_APP_GATEWAY_QXS}common/v1/commodity/subject-commodity-list`, // 专题商品列表
  specialShopDetail: `${VUE_APP_GATEWAY_QXS}common/v1/subject/subject-detail`, // 专题信息
  packetInfo: `${VUE_APP_GATEWAY_MALL}product/redPackage-get`, // 红包信息
  addCart: `${VUE_APP_GATEWAY_MALL}cart/add`, // 加入购物车
  cartCount: `${VUE_APP_GATEWAY_MALL}cart/query/item/count`, // 购物车数量
  getCartProduct: `${VUE_APP_GATEWAY_MALL}cart/list`, // 购物车列表
  addCartCount: `${VUE_APP_GATEWAY_MALL}cart/incrItem`, // 购物车单个商品增加数量
  delCartCount: `${VUE_APP_GATEWAY_MALL}cart/decrItem`, // 购物车单个商品减少数量
  ShopSettlement: `${VUE_APP_GATEWAY_MALL}order/submitOrder`, // 提交结算订单
  submitVirtualOrder: `${VUE_APP_GATEWAY_MALL}order/submitVirtualOrder`, // 提交虚拟订单
  getOrderList: `${VUE_APP_GATEWAY_MALL}order/queryOrderList`, // 订单列表
  closeOrder: `${VUE_APP_GATEWAY_MALL}order/cancel`, // 取消订单
  getDelivery: `${VUE_APP_GATEWAY_MALL}order/query/distribute`, // 物流详情
  getAfterSaleSupport: `${VUE_APP_GATEWAY_MALL}order/after/sale/support`, // 是否支持售后服务 和 服务列表
  getAfterSaleDetail: `${VUE_APP_GATEWAY_MALL}order/after/sale/queryDetail`, // 售后详情
  submitAfterSale: `${VUE_APP_GATEWAY_MALL}order/after/sale/submit`, // 提交售后申请
  confirmDelivery: `${VUE_APP_GATEWAY_MALL}order/after/sale/submit/deliver`, // 提交单号 确认发货
  closeAfterSale: `${VUE_APP_GATEWAY_MALL}order/after/sale/cancel`, // 取消售后
  getCustomerBill: `${VUE_APP_GATEWAY_MALL}order/getCustomerBill`, // 获取结算详情
  areaCodeList: `${VUE_APP_GATEWAY_MALL}address/areaCodeList`, // 查询地址编码
  setDefaultAddress: `${VUE_APP_GATEWAY_MALL}address/setDefaultAddress`, // 设置默认地址
  checkProductSaleAble: `${VUE_APP_GATEWAY_MALL}product/checkProductSaleAble`, // 根据默认地址查询区域可售性
  managementColumnList: `${VUE_APP_GATEWAY_MALL}column-management/column-list`, // 商城栏目列表查询
  subjectList: `${VUE_APP_GATEWAY_MALL}ksh/subject/list`, // 专题+瀑布流图片查询
  // 活动
  redPacket: `${VUE_APP_GATEWAY_KSH}doctor/v1/person/events`, // 是否需要显示红包弹窗
  kitExchange: `${VUE_APP_GATEWAY_MALL}product/get_red_package`, // 积分兑换
  // 我的
  getRepresentUserDetail: `${VUE_APP_GATEWAY_QXS}represent/v1/person/detail`, // 获取代表信息
  sureReceive: `${VUE_APP_GATEWAY_MALL}order/confirm/finish`, // 确认收货
  orderDetail: `${VUE_APP_GATEWAY_MALL}order/queryOrderDetail`, // 商品订单详情
  getPharmacyDetail: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/show-drugstore-info`, // 获取药店信息
  onUpdatePharmacyInfo: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/update-drugstore-info`, // 更新药店信息
  ocrLicense: `${VUE_APP_GATEWAY_QXS}common/v1/ocr-license`, // 营业执照识别
  // 患者
  checkDoctorAuthority: `${VUE_APP_GATEWAY_QXS}doctor/v1/auth/switch_patient`,
  getPatientInfo: `${VUE_APP_GATEWAY_KSH}doctor/v1/patient/info`,
  getPatientList: `${VUE_APP_GATEWAY_KSH}doctor/v1/patient/list`,
  getPersontInfo: `${VUE_APP_GATEWAY_QXS}doctor/v1/person/info`,
  getDoctorQrCode: `${VUE_APP_GATEWAY_QXS}doctor/v1/person/qr_code`,
  getDoctorLabelList: `${VUE_APP_GATEWAY_KSH}doctor/v1/person/labels`,
  getConsultList: `${VUE_APP_GATEWAY_QXS}consultation/v1/consult/list`,
  updateDoctorLabel: `${VUE_APP_GATEWAY_KSH}doctor/v1/person/label`,
  getPatientLabelList: `${VUE_APP_GATEWAY_QXS}doctor/v1/patient/labels`,
  updatePatientLabel: `${VUE_APP_GATEWAY_KSH}doctor/v1/patient/label`,
  consultBaseInfo: `${VUE_APP_GATEWAY_QXS}consultation/v1/consult/detail`,
  consultSubmit: `${VUE_APP_GATEWAY_QXS}consultation/v1/consult/reply`,
  getConsultMsgList: `${VUE_APP_GATEWAY_QXS}consultation/v1/consult/reply_list`,
  onDelConsult: `${VUE_APP_GATEWAY_KSH}doctor/v1/patient/delete_consult`,
  getConsultUnReadCount: `${VUE_APP_GATEWAY_QXS}doctor/v1/patient/reply_count`,
  // 问卷
  questionnaireView: `${VUE_APP_GATEWAY_QXS}doctor/v1/questionnaire/view`, // 预览问卷题目详情
  questionnairePreview: `${VUE_APP_GATEWAY_QXS}common/v1/questionnaire/preview`, // 预览问卷题目详情
  submitQuestionnaireQuestion: `${VUE_APP_GATEWAY_QXS}doctor/v1/questionnaire/submit`, // 提交问卷
  saveQuestionnaire: `${VUE_APP_GATEWAY_QXS}doctor/v1/questionnaire/answer`, // 保存问卷

  showNextExam: `${VUE_APP_GATEWAY_QXS}doctor/v1/questionnaire/show-next-exam`, // 医生问卷调研下一题展示，是根据当前题信息返回下一题信息
  continueAnswer: `${VUE_APP_GATEWAY_QXS}doctor/v1/questionnaire/continue-answer-exam-or-not`, // 医生是否继续答题，如果继续答题，返回答题时最后一道题的前一题信息，否则清空所有答题信息
  showQuestionnaireExam: `${VUE_APP_GATEWAY_QXS}doctor/v1/questionnaire/show-questionnaire-exam`, // 医生调研单个题目的展示，若答过题则显示用户答题选项，否则预览该题目

  // 新趣课堂
  acceptDelegation: `${VUE_APP_GATEWAY_QXS}doctor/code/accept-delegation`,    // 接受委托
  getConferenceDetail: `${VUE_APP_GATEWAY_QXS}doctor/v1/meeting/view`,
  conferenceScore: `${VUE_APP_GATEWAY_QXS}doctor/v2/meeting/save-meeting-grade`, // 趣课堂打分
  recordConferenceTime: `${VUE_APP_GATEWAY_QXS}doctor/v2/meeting/save-view-time`, // 观看视频 十秒保存一次
  onReceiveConferenceExamGift: `${VUE_APP_GATEWAY_QXS}doctor/v2/meeting/receive-exam-gift`, // 手动领取第一次趣课堂答题奖励
  receiveConferenceGift: `${VUE_APP_GATEWAY_QXS}doctor/v2/meeting/receive-view-gift`, // 领取观看趣课堂 领取中间掉落积分数据
  submitConferenceExam: `${VUE_APP_GATEWAY_QXS}doctor/v2/meeting/submit-answer`, // 提交趣课堂题目答案
  conferenceKnowledgeList: `${VUE_APP_GATEWAY_QXS}`, // 新趣课堂暂时没有用到

  // 通用
  publicCommentList: `${VUE_APP_GATEWAY_QXS}common/comment/v1/scene/comment/list`, // 通用场景评论列表
  onCommentScene: `${VUE_APP_GATEWAY_QXS}common/comment/v1/comment`, // 通用提交问题
  getCommentDetail: `${VUE_APP_GATEWAY_QXS}common/comment/v1/comment-detail`,
  platformDepartments: `${VUE_APP_GATEWAY_QXS}/common/v1/platform-departments`, // 平台科室列表
  onUnlockScene: `${VUE_APP_GATEWAY_QXS}common/v1/scene/confirm-unlock`, // 解锁场景积分
  getAdvert: `${VUE_APP_GATEWAY_QXS}common/v1/code/get_advert_by_code_id`, // 查询码对应的assign_code_id对应的广告位

  // 平台信息
  getSystemMessageList: `${VUE_APP_GATEWAY_QXS}doctor/live/v1/get-platfrom-notify`, // 平台信息通知
  getSystemMessageUnreadCount: `${VUE_APP_GATEWAY_QXS}doctor/v1/system-message/unread-count`, // 系统消息未读数
  getAppDownLoadUrl: `${VUE_APP_GATEWAY_QXS}public/v1/push-client/latest-version`,
  // 趣直播模块
  checkLive: `${VUE_APP_GATEWAY_QXS}common/live/v1/get-answer-tip`, // 趣直播检测
  getIndexLiveList: `${VUE_APP_GATEWAY_QXS}doctor/live/v1/list`, // 首页趣直播列表
  getLiveHistoryList: `${VUE_APP_GATEWAY_QXS}common/live/v1/history-list`, // 趣直播历史列表
  getRecommenLiveList: `${VUE_APP_GATEWAY_QXS}common/live/v1/speaker/push-list-V2`, // 讲者推荐趣直播会议
  getCouldLiveList: `${VUE_APP_GATEWAY_QXS}doctor/shop/v1/live-list`, // 课堂趣直播会议列表
  getCouldStarList: `${VUE_APP_GATEWAY_QXS}doctor/shop/v1/shop-list`, // 趣直播明星列表
  getLiveDetail: `${VUE_APP_GATEWAY_QXS}common/live/v1/view`, // 趣直播详情
  onSubmitSpeaker: `${VUE_APP_GATEWAY_QXS}doctor/v1/speaker/submit-speaker-certify`, // 提交讲者审核
  onUploadImage: `${VUE_APP_GATEWAY_QXS}common/v1/upload-image`, // 图片上传
  getSpeakerGiftRecord: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/fund-flow`, // 视频服务费收支明细
  getUserImSig: `${VUE_APP_GATEWAY_QXS}common/v1/get-im-info`, // 获取im登陆userSig
  getLivePacketKey: `${VUE_APP_GATEWAY_QXS}common/live/v1/get-red-packet`, // 查看趣直播间红包密钥
  onReceiveLivePacket: `${VUE_APP_GATEWAY_QXS}doctor/live/v1/receive-red-packet`, // 领取趣直播红包
  getLiveHistoryMsg: `${VUE_APP_GATEWAY_QXS}common/live/v1/msg-list`, // 获取趣直播间历史消息,
  onReceiveLiveGift: `${VUE_APP_GATEWAY_QXS}doctor/live/v1/receive-gift`, // 趣直播奖励
  onRecordLiveViewTime: `${VUE_APP_GATEWAY_QXS}common/live/v1/record-time`, // 记录趣直播观看时长
  shareScene: `${VUE_APP_GATEWAY_QXS}common/v1/share-content`, // 分享场景回调
  getGiftList: `${VUE_APP_GATEWAY_QXS}common/live/v1/live-gift-list`, // 礼物列表
  getHelpList: `${VUE_APP_GATEWAY_QXS}common/live/v1/help-list-info`, // 趣直播助力榜
  getMyHelpList: `${VUE_APP_GATEWAY_QXS}common/live/v1/my-help-info`, // 我的助力榜
  payGift: `${VUE_APP_GATEWAY_QXS}common/live/v1/send-gift`, // 支付礼物
  checkItemGift: `${VUE_APP_GATEWAY_QXS}common/live/v1/live-gift`, // id查询单个礼物
  getLiveGift: `${VUE_APP_GATEWAY_QXS}doctor/live/v1/recv-gift-list`, // 趣直播收益列表
  putOnShelves: `${VUE_APP_GATEWAY_QXS}doctor/live/v1/edit-hide-status`, // 上下架视频接口
  getCashDetail: `${VUE_APP_GATEWAY_QXS}doctor/live/v1/gift-detail`, // 单个趣直播流水列表
  getLiveSimpleInfo: `${VUE_APP_GATEWAY_QXS}common/live/v1/simple-info`, // 获取趣直播简单信息
  submitLiveExam: `${VUE_APP_GATEWAY_QXS}doctor/live/v1/submit/live-exam-answer`, // 提交live题目答案
  onReceiveLiveExamGift: `${VUE_APP_GATEWAY_QXS}doctor/live/v1/settle/live-exam-answer`, // 手动领取第一次趣课堂答题奖励
  permissionForLive: `${VUE_APP_GATEWAY_QXS}common/live/v1/permission-for-live`, // 是否在白名单内
  onlineStremCount: `${VUE_APP_GATEWAY_QXS}common/live/v1/online_stream_count`, // 当前在线流个数
  infoCollection: `${VUE_APP_GATEWAY_QXS}doctor/live/v1/submit/infoCollection`, // 医生信息采集表单提交

  // 讲者
  getLiveSpeakerInfo: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/speaker-info`,
  getSpeakerGiftCount: `${VUE_APP_GATEWAY_QXS}doctor/v1/person/account-show`, // 医生账户信息
  getThirdPartySignInfo: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/get-third-party-sign-info`, // 医生签约第三方信息
  dealChatMsg: `${VUE_APP_GATEWAY_QXS}common/live/v1/deal-chat-msg`, // 处理趣直播间消息
  getBlackLiveList: `${VUE_APP_GATEWAY_QXS}common/live/v1/black-list`, // 趣直播的黑名单
  handleBlackList: `${VUE_APP_GATEWAY_QXS}common/live/v1/black-list-deal`, // 移出加入趣直播的黑名单
  getLiveHistoryMessageList: `${VUE_APP_GATEWAY_QXS}common/live/v1/msg-list`, // 回放趣直播的老消息列表
  getSpeakerLiveDetail: `${VUE_APP_GATEWAY_QXS}doctor/speaker/v1/live-detail`, // 讲者趣直播详情
  getLiveDynamicData: `${VUE_APP_GATEWAY_QXS}common/live/v1/dynamic-data`, // 趣直播动态数据
  getSpeakerDetail: `${VUE_APP_GATEWAY_QXS}common/live/v1/doctor/speaker-detail`, // 获取医生讲者信息
  onSpeakerCash: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/apply-withdraw`, // 讲者提现
  onSubmitThirdPartySign: `${VUE_APP_GATEWAY_QXS}doctor/v1/speaker/submit-third-party-sign`, //  灵共平台签约
  agreeAgreement: `${VUE_APP_GATEWAY_QXS}doctor/v1/speaker/agree-agreements`, //  讲者同意各类协议
  // 微信&积分支付
  getAuthStatus: `${VUE_APP_GATEWAY_MALL}wechat/auth/status`, // 判断是否授权
  getAuthLink: `${VUE_APP_GATEWAY_MALL}wechat/get/auth/link`, // 获取授权链接
  getCallBack: `${VUE_APP_GATEWAY_MALL}wechat/auth/call/back`, // 授权回调
  getPrePay: `${VUE_APP_GATEWAY_MALL}pay/wechat/pre/pay`, // 微信预下单
  getQueryBill: `${VUE_APP_GATEWAY_MALL}pay/query/bill`, // 获取支付账单信息
  getIntegrationPay: `${VUE_APP_GATEWAY_MALL}pay/integration/pay`, // 积分支付
  getPayStatus: `${VUE_APP_GATEWAY_MALL}pay/query/pay/status`, // 支付结果查询
  getExpireOrder: `${VUE_APP_GATEWAY_MALL}order/close/expire/order`, // 取消订单
  postWechatPrepay: `${VUE_APP_GATEWAY_MALL}pay/single/wechat/prepay`, // 趣直播充值-微信支付
  // 帮助中心
  getArticleList: `${VUE_APP_GATEWAY_QXS}common/article/v1/list`, // 文章列表
  getArticleDetail: `${VUE_APP_GATEWAY_QXS}common/article/v1/detail`, // 文章详情
  getArticleMark: `${VUE_APP_GATEWAY_QXS}common/article/v1/mark`, // 标记喜欢或没用
  postFeedback: `${VUE_APP_GATEWAY_QXS}common/platform-feedback/v1/add`, // 新增平台反馈
  postGoodProductRecommend: `${VUE_APP_GATEWAY_QXS}common/platform-feedback/v1/add-product-recommendation`, // 好物共建-提交荐品
  setVerifyCodeUpdateMobile: `${VUE_APP_GATEWAY_QXS}common/v1/mobile/change`, // 修改手机号
  setFaceAuthUpdateMobile: `${VUE_APP_GATEWAY_QXS}doctor/safe-center/change-mobile-with-face-token`, // 人脸识别修改手机号 已登陆
  setUnLoginFaceAuthUpdateMobile: `${VUE_APP_GATEWAY_QXS}public/change-mobile-with-face-token`, // 人脸识别修改手机号 未登陆
  onApplyUserUnseal: `${VUE_APP_GATEWAY_QXS}doctor/safe-center/apply-unfrozen`, // 申请解冻
  // 药店
  changeRegisterType: `${VUE_APP_GATEWAY_QXS}doctor/v1/doctor/change-register-type`, // 切换注册类型
  getUserNotify: `${VUE_APP_GATEWAY_QXS}common/v1/notify-list`, // 是否需要弹出提醒，弹且只弹一次
  onAgreeNotify: `${VUE_APP_GATEWAY_QXS}common/v1/certify-notify-agreement`, // 确认弹窗
  // 新拜访
  getNewVisitList: `${VUE_APP_GATEWAY_QXS}doctor/academic-visit/list`, // 新拜访列表
  getNewVisitItem: `${VUE_APP_GATEWAY_QXS}doctor/academic-visit/detail`, // 新拜访内容
  submitNewExam: `${VUE_APP_GATEWAY_QXS}doctor/academic-visit/submit-exam`, // 提交拜访问卷、题目选项
  realNameAuthCount: `${VUE_APP_GATEWAY_QXS}common/v1/should-manual-audit`,
  hasBindRep: `${VUE_APP_GATEWAY_QXS}doctor/v1/person/is-bind`,
  // 自定义科室
  onSearchHospital: `${VUE_APP_GATEWAY_QXS}common/v1/hospital-list`, // 搜索医院
  onSearchDepartment: `${VUE_APP_GATEWAY_QXS}common/hospital/department/search`, // 根据医院获取医院科室
  // 活动
  getWebSignUpUserInfo: `${VUE_APP_GATEWAY_QXS}doctor/live/activity/user-sign-up/info`, // 获取报名信息
  onWebSignUp: `${VUE_APP_GATEWAY_QXS}doctor/live/activity/sign-up`, // 用户活动报名
  webSignUpPay: `${VUE_APP_GATEWAY_QXS}doctor/live/activity/pay`, // 活动支付
  getWebSignUpDetail: `${VUE_APP_GATEWAY_QXS}public/activity`,
  // 课程列表
  getSpeakerHome: `${VUE_APP_GATEWAY_QXS}doctor/v1/get-speaker-home-enable`, // 获得大咖讲堂的开关
  getCourseSearchList: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}public/course/search-list`, // 趣宣讲-获取课程列表 - 景天
  getTagList: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}course/search-course-hot-tag`, // 通过条件获取一组标签信息
  getSearchTagCourseList: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}course/search-tag-course`, // 根据标签id查询一组标签
  getCourseDetail: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}public/course/detail`, // 趣宣讲-大咖讲堂课程详情
  collectAdd: `${VUE_APP_GATEWAY_QXS}doctor/collect/add`, // 趣宣讲-收藏课程
  cancelCollectAdd: `${VUE_APP_GATEWAY_QXS}doctor/collect/cancel`, // 趣宣讲-取消收藏课程
  coursePlayUrl: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}course/play-url`, //  获取课程播放地址
  saveViewTime: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}course/save-view-time`, //  记录观看课程时间
  searchDoctorCourse: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}course/search-doctor-course`, // 知识店铺详情
  focusSpeaker: `${VUE_APP_GATEWAY_QXS}focus/focus-speaker`, // 关注讲者
  focusSpeakerList: `${VUE_APP_GATEWAY_QXS}focus/speaker-list`, // 关注的讲者列表
  collectSearchList: `${VUE_APP_GATEWAY_QXS}doctor/collect/search-list`, // 收藏课程列表
  specialSpeakerInfo: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}public/person/query/special-speaker-info`, // 查询特约讲者信息
  accountAll: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/search-gift-bean`, // 查看账户信息
  beanAccount: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}person/query/bean-trade-statistics-data`, // 查询趣豆统计数据及余额
  beanDetailList: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}trade/fun-bean-detail-list`, // 趣豆明细列表
  speakerAccount: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}person/query/rmb-trade-statistics-data`, // 查询账户统计数据
  speakerDetailList: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}trade/rmb-detail-list`, // 查询账户统明细列表
  canWithdrawAmount: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}trade/query/can-withdraw-amount`, // 查询可提现金额
  applyWithdraw: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}trade/apply-withdraw`, // 申请提现
  queryCourseFee: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}trade/batch-purchase/query-course-fee`, // 	获取购买时所需的账户数据
  submitOrder: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}trade/submit-order`, // 提交订单，获得订单id
  queryOrderBill: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}trade/query-order-bill`, // 查询支付信息
  knowledgeOrderPay: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}trade/order-pay`, // 课程订单支付
  wechatPayResult: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}trade/query/wechat-pay-result`, // 查询微信或者混合支付结果
  withdrawingAmount: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}person/query/withdrawing-amount`, // 查询体现中余额

  getFunBeanList: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/notice-fun-bean`, // 趣豆获取规则列表
  getRecommendedList: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}course/recommended-list`, //
  getShareQrCode: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}share/qr-code`, // 查看分享二维码
  getInviteQrCode: `${VUE_APP_GATEWAY_QXS}doctor/v1/invite/qr_code`, // 医生邀请医生二维码
  shareCourse: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}share/course`, // 分享课程
  shareSpeaker: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}share/speaker`, // 分享知识店铺
  getTaskFunBean: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}funBean-rule/get-task-fun-bean`, // 通过任务获得趣豆
  getFunBeanRuleList: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}funBean-rule/list`, // 趣豆获取规则列表
  getShareHandle: `${VUE_APP_GATEWAY_QXS}doctor/share/handle`, // 分享链接授予权限
  getCollectStatus: `${VUE_APP_GATEWAY_QXS}doctor/collect/isCollect`, // 获得是否收藏
  getSearchCourseList: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}course/forum-search-list`, // 大咖讲堂课程搜索
  getRmbAccontInfo: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}person/query/rmb-account-info`, // 查询课程和讲者余额信息
  getLiveSpeakerAmount: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}person/query/live-speaker-amount`, // 获取讲者统计信息
  getLimitStatus: `${VUE_APP_GATEWAY_QXS}doctor/v1/get-limit-status`, // 获取是否是限定医生
  getPurchasedRecommendedList: `${VUE_APP_GATEWAY_KNOWLEDGE_MALL}course/to-be-purchased-recommended-list`, // 获取是否是限定医生

  // 趣直播红包
  getRedPacketExam: `${VUE_APP_GATEWAY_QXS}doctor/live/v1/get-red-packet-exam`, // 获取红包题目
  redPacketExamAnswer: `${VUE_APP_GATEWAY_QXS}doctor/live/v1/submit/red-packet-exam-answer`, // 一次、二次提交红包题目 根据前端传递的参数判断是否是二次答题
  settleRedPacketExamAnswer: `${VUE_APP_GATEWAY_QXS}doctor/live/v1/settle/red-packet-exam-answer`, // 手动结算第一次提交的红包题目答案

  // 高登暂时关闭，使用人力家认证
  renlijiaAutor: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/check-gd-and-rlj-service`, // 是否显示 去认证人力家的弹窗
  getUserSupportDetail: `${VUE_APP_GATEWAY_QXS}doctor/safe-center/query-user-info`, // 查询安全中心用户信息
  getUserRecallGiftList: `${VUE_APP_GATEWAY_QXS}doctor/safe-center/query-recall-list`, // 查询可撤回明细列表
  onRecallUserGift: `${VUE_APP_GATEWAY_QXS}doctor/safe-center/recall-amount`, // 退回积分/视频服务费
  onUserLogoff: `${VUE_APP_GATEWAY_QXS}doctor/safe-center/cancel-account`, // 注销账号
  onValidUserMobile: `${VUE_APP_GATEWAY_QXS}public/check-mobile`, // 查看手机号码是否可存在
  getUserAccountInfo: `${VUE_APP_GATEWAY_QXS}common/account/info`, // 获取用户的账户余额
  getThirdPartyUrl: `${VUE_APP_GATEWAY_QXS}common/v1/third-party/get-sign-link`, // 获取第三方平台签约链接
  getSpeakerFailInfo: `${VUE_APP_GATEWAY_QXS}doctor/v1/speaker/sign-fail-info`, // 讲者签约审核失败信息返回
  reSubmitSpeakerInfo: `${VUE_APP_GATEWAY_QXS}doctor/v1/speaker/re-submit-sign`, // 医生重新提交讲者签约信息

  // 售后订单
  applyCancelBeforeDeliver: `${VUE_APP_GATEWAY_MALL}order/apply-cancel-before-deliver`, // 申请取消订单
  applyCancelStatus: `${VUE_APP_GATEWAY_MALL}order/apply-cancel-status`, // 申请取消订单状态
  getAfterSalesList: `${VUE_APP_GATEWAY_MALL}order/after/sale/list`, // 售后订单列表
  getExpressInfoList: `${VUE_APP_GATEWAY_MALL}address/getExpressInfoList`, // 查询快递信息列表
  getDashboard: `${VUE_APP_GATEWAY_MALL}order/dashboard`, // 订单看板
  getQueryAfterSaleInfo: `${VUE_APP_GATEWAY_MALL}order/after/sale/queryAfterSaleInfo`, // 支持的售后类型
  getAfterSaleReturn: `${VUE_APP_GATEWAY_MALL}order/after/sale/returnTypes`, // 支持的售后取货类型
  getItemVo: `${VUE_APP_GATEWAY_MALL}order/after/sale/queryRefundItem`, // 获得的售后商品信息
  getAfterSaleReasonList: `${VUE_APP_GATEWAY_MALL}policy/getAfterSaleReasonListBySupplierAndServiceType`, // 售后原因

  // 品宣
  getAcademicList: `${VUE_APP_GATEWAY_QXS}doctor/branding/list`, // 活动列表
  getAcademicCount: `${VUE_APP_GATEWAY_QXS}doctor/branding/academic-exchange-circle/red-point-count`, // 活动未读小红点
  getCancelAcademicCount: `${VUE_APP_GATEWAY_QXS}doctor/branding/academic-exchange-circle/read-red-point`, // 取消活动未读小红点
  addViewCount: `${VUE_APP_GATEWAY_QXS}doctor/branding/push/add-view-count`, // 统计外链的访问次数

  // 美团
  getH5AccessUrl: `${VUE_APP_GATEWAY_MALL}mt/access/getH5AccessUrl`, // 请求跳转美团页面
  userDelOrder: `${VUE_APP_GATEWAY_MALL}order/userDelOrder`, // 删除订单
  getMtNoPayCarOrder: `${VUE_APP_GATEWAY_MALL}order/getMtNoPayCarOrder`, // 删除订单

  // 秒杀活动
  getSecKillDetail: `${VUE_APP_GATEWAY_MALL}activity/getSecKillDetail`, // 专题详情
  getSecKillProductList: `${VUE_APP_GATEWAY_MALL}product/secKillProductList`, // 秒杀活动详情
  setSecKillBook: `${VUE_APP_GATEWAY_MALL}secondKill/book`, // 秒杀商品详情预约
  getSecKillUrl: `${VUE_APP_GATEWAY_MALL}secondKill/getSecKillUrl`, // 获取秒杀动态URL
  getSecKillExecute: `${VUE_APP_GATEWAY_MALL}secondKill/execute`, // 秒杀商品
  checkOrderCreateStatus: `${VUE_APP_GATEWAY_MALL}order/checkOrderCreateStatus`, // 检查订单是否创建成功
  checkWaitingForPayOrder: `${VUE_APP_GATEWAY_MALL}order/waitingForPayOrder`, // 检查订单是否创建成功
  getActivityArea: `${VUE_APP_GATEWAY_MALL}activity/getActivityArea`, // 获取活动专区

  // --------------------- 618活动 -----------------------
  // 618活动详情
  getRebateActivityDiscountInfo: `${VUE_APP_GATEWAY_MALL}activity/getRebateActivityDiscountInfo`,
  // 618活动抽奖
  signUpForCampaign: `${VUE_APP_GATEWAY_MALL}activity/signUpForCampaign`,

  // --------------------- 委托服务 -----------------------
  // 收集满意度调查
  collectSurveySatisfaction: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/collect-survey-satisfaction`,
  // 各大场景答题结算和查看任务详情时的弹窗信息
  codeNoticeInfo: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/code-notice-info`,

  // --------------------- 商品搜搜上报 -----------------------
  uploadUserClickSpuEvent2Alibaba: `${VUE_APP_GATEWAY_MALL}product/uploadUserClickSpuEvent2Alibaba`,

  createTcccUserSig: `${VUE_APP_GATEWAY_QXS}common/tccc/create-user-sig`,

  // --------------------- 风控 -----------------------

  // 校验短信验证码
  validateSmsCode: `${VUE_APP_GATEWAY_RISK_CONTROL_API}sms/validateSmsCode`,
  // 获取发送短信的手机号
  getSendMobile: `${VUE_APP_GATEWAY_RISK_CONTROL_API}sms/getSendMobile`,
  // 发送短信验证码
  sendSmsCode: `${VUE_APP_GATEWAY_RISK_CONTROL_API}sms/sendSmsCode`,
  // 获取用户信息
  getUserCertifyInfo: `${VUE_APP_GATEWAY_RISK_CONTROL_API}face/getUserCertifyInfo`,
  // 获取人脸核身腾讯云参数
  getFaceIdInfo: `${VUE_APP_GATEWAY_RISK_CONTROL_API}face/getFaceIdInfo`,
  // 获取用户应该使用的人脸服务类型
  getFaceServerType: `${VUE_APP_GATEWAY_RISK_CONTROL_API}face/getFaceServerType`,
  selfBuildFaceMatch: `${VUE_APP_GATEWAY_RISK_CONTROL_API}face/selfBuildFaceMatch`, // 自建人脸比对
  selfBuildNoAuthMatch: `${VUE_APP_GATEWAY_RISK_CONTROL_API}no-auth/selfBuildFaceMatch`, // 自建人脸比对
  selfBuildFaceVideoVerify: `${VUE_APP_GATEWAY_RISK_CONTROL_API}face/selfBuildFaceVideoVerify`, // 上传人脸视频
  selfBuildNoAuthVideoVerify: `${VUE_APP_GATEWAY_RISK_CONTROL_API}no-auth/selfBuildFaceVideoVerify`, // 上传人脸视频
  getCreateVideo: `${VUE_APP_GATEWAY_RISK_CONTROL_API}upload/video/get-create-video`, // 获取上传凭证
  refreshUploadVideo: `${VUE_APP_GATEWAY_RISK_CONTROL_API}upload/video/refresh-upload-video`, // 刷新上传凭证
  // 获取人脸核身结果
  getFaceRiskResult: `${VUE_APP_GATEWAY_RISK_CONTROL_API}face/getFaceAuthResult`,

  // -------------------------- 播客 -------------------------------------

  // 播客邀约详情
  getChallengeBaseInfo: `${VUE_APP_GATEWAY_QXS}common/v1/get-challenge-base-info`,
  // 播客邀约我的作品
  getMyWorkInfo: `${VUE_APP_GATEWAY_QXS}doctor/medical-podcast/v1/my-work-info`,
  // 播客邀约 报名
  registerPodcastInvitation: `${VUE_APP_GATEWAY_QXS}doctor/medical-podcast/v1/register-podcast-invitation`,
  // 医生需要同意的协议
  needAgreeAgreements: `${VUE_APP_GATEWAY_QXS}doctor/v1/need-agree-agreements`,
  // 播客详情
  medialPodcastView: `${VUE_APP_GATEWAY_QXS}doctor/medical-podcast/v1/view`,
  // 播客邀约列表
  getPodcastInvitationList: `${VUE_APP_GATEWAY_QXS}doctor/medical-podcast/v1/speaker/podcast-invitation-list`,

  // 活动内容喜欢数/不喜欢数
  attitudeCount: `${VUE_APP_GATEWAY_QXS}doctor/scene/attitude-count`,
  // 用户活动反馈记录保存
  recordSave: `${VUE_APP_GATEWAY_QXS}doctor/scene/record-save`,
  parseDetailInfo: `${VUE_APP_GATEWAY_QXS}common/video/parse/detail-info`, // 解析视频详情
  getFeedList: `${VUE_APP_GATEWAY_QXS}doctor/feed/v1/feed-list`, // 动态列表
  getCurrentMsg: `${VUE_APP_GATEWAY_QXS}doctor/feed/v1/get-msg`, // 获取当前消息
  feedView: `${VUE_APP_GATEWAY_QXS}doctor/feed/v1/view`, // 浏览量

  // 日常优化
  // 商城是否展示权限
  shopIsShow: `${VUE_APP_GATEWAY_MALL}common/main/isShow`,

  previewPureQuestionnaire: `${VUE_APP_GATEWAY_QXS}common/questionnaire/v1/preview`, // 预览问卷
  getPccArticleDetail: `${VUE_APP_GATEWAY_QXS}doctor/medical-podcast/v1/get-podcast-article-detail`, // 播客文章详情
  getPlatformLaborStatus: `${VUE_APP_GATEWAY_QXS}common/v1/platform-labor-enabled`,
  expectTax: `${VUE_APP_GATEWAY_QXS}doctor/v1/common/apply-with-draw/expect-tax`, // 预估税费
  acceptPureQuest: `${VUE_APP_GATEWAY_QXS}doctor/code/accept-pure-quest`,
  getFollowPodcastList: `${VUE_APP_GATEWAY_QXS}doctor/medical-podcast/v1/speaker/follow-podcast-list`, // 获取已关注的播客列表
  updateFollowPodcast: `${VUE_APP_GATEWAY_QXS}doctor/follow-activity/update`,
  followChallengeSubmission: `${VUE_APP_GATEWAY_QXS}doctor/medical-podcast/v1/follow-challenge-submission`,

  // --------------------- 云智签约 -----------------------
  getDoctorSignInfo: `${VUE_APP_GATEWAY_QXS}doctor/sign/info`, // 获取云智签约信息
  submitDoctorSign: `${VUE_APP_GATEWAY_QXS}doctor/sign/submit`, // 提交云智签约信息
  confirmDoctorSign: `${VUE_APP_GATEWAY_QXS}doctor/sign/confirm` // 确认签约
}
